<template>
  <div>
    <div class="d-flex" style="margin-top: 15px">
      <div class="teamSelectedChildDiv mr-4" v-if="selectedContacts.length">
        <span class="mr-4">{{ selectedContacts.length }} Member Selected</span>
        <i
          class="fas fa-envelope mr-3 mt-1 handCls"
          v-if="checkBulkActions"
          @click="sendBulkEmail"
        ></i>
        <i
          class="fas fa-trash-alt mr-3 mt-1 handCls"
          v-if="checkBulkActions"
          @click="bulkDelete"
        ></i>
      </div>
      <div class="form-group has-search">
        <span
          class="fa fa-search form-control-feedback"
          style="margin-top: 0"
        ></span>
        <input
          type="text"
          class="form-control upcoming-tasks-search"
          aria-controls="datatables"
          v-model="searchQuery"
          style="width: 203px"
          placeholder="Search Records"
        />
      </div>
      <div>
        <button
          class="newTask filterBtn ml-2"
          style="border: 0px; height: 100%"
          @click="showFilter = !showFilter"
        >
          <img src="static/img/filter.svg" class="mr-1" />
          Filters
        </button>
        <All v-if="showFilter"></All>
      </div>
    </div>
    <div class="row ml-0 mr-0 mb-2 mt-2">
      <div class="w-100">
        <div
          class="tabulator quickTask"
          ref="table"
          style="width: 100%; height: 100%"
        ></div>
      </div>
    </div>
    <custom-menu></custom-menu>
    <DialogSendEmail
      @emit-sucess="emitSuccess"
      v-model="dialogSendEmail"
    ></DialogSendEmail>
    <DialogAddContact v-model="dialogPeopleData"></DialogAddContact>
    <el-dialog
      center
      title="Really Delete?"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      width="750px"
      style="margin: 0 auto"
      :visible.sync="confirmMdlShow"
      class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div class="card-body">
        <div class="inputs row">
          <p style="width: 100%; text-align: center">
            Are you sure you want to delete this user? This can't be undone.
          </p>
        </div>
        <div class="actionbuttons">
          <button
            @click.prevent="handleCancel"
            class="todo-form-cancel-button btn-outline-secondary"
          >
            Cancel
          </button>
          <button
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
            :disabled="submitted"
            @click="deleteMethod"
          >
            Yes
            <b-spinner v-if="submitted" small label="Spinning"></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";
import All from "../Pages/All";
import Tabulator from "tabulator-tables";
import moment from "moment";
import CustomMenu from "../Components/CustomMenu.vue";
import { Select, Option, Dialog } from "element-ui";
import DialogAddContact from "../Dialogs/DialogAddContact";
import DialogSendEmail from "../Dialogs/DialogSendEmail";
export default {
  data() {
    return {
      showFilter: false,
      companiesList: [],
      selectedContacts: [],
      tableData: [],
      filterJson: {},
      searchQuery: "",
      deleteItem: {},
      bulkSelected: false,
      confirmMdlShow: false,
      submitted: false,
      dialogSendEmail: {
        isShow: false,
        data: {},
      },
      dialogPeopleData: {
        isShow: false,
        data: {},
        isCreate: true,
      },
      tabulator: null,
      searchFilter: [],
      isFilterApplied: false,
      customFilterArray: [],
    };
  },
  components: {
    All,
    DialogAddContact,
    [CustomMenu.name]: CustomMenu,
    DialogSendEmail,
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
  },
  methods: {
    sendBulkEmail() {
      if (this.selectedContacts.length > 0) {
        let emails = [];
        this.selectedContacts.map((item) => {
          if (item.email) emails.push(item.email);
        });
        this.dialogSendEmail = {
          isShow: true,
          data: { emails, component: "Contact" },
        };
      }
    },
    emitSuccess() {
      this.tabulator.deselectRow();
    },
    handleCancel() {
      this.confirmMdlShow = false;
      this.submitted = false;
      this.deleteItem = {};
    },
    bulkDelete() {
      this.bulkSelected = true;
      this.confirmMdlShow = true;
    },
    deleteMethod() {
      let self = this;
      this.submitted = true;
      let payload = [];
      if (this.bulkSelected && this.selectedContacts.length > 0) {
        this.selectedContacts.map((item) => {
          payload.push(item.master_pid);
        });
      } else {
        payload.push(this.deleteItem.master_pid);
      }
      self.$store
        .dispatch("contacts/apiDeleteContact", payload)
        .then((data) => {
          this.$toaster.success("Deleted successfully.");
          payload.map((item) => {
            self.tabulator.deleteRow(item);
          });
          self.handleCancel();
        })
        .catch((err) => {
          self.$toaster.error("Fail to delete contact");
          self.submitted = false;
          console.log("Fail to delete contact data", { err });
        });
    },
    handleEditContact(data) {
      let self = this;
      self.dialogPeopleData = {
        isShow: true,
        data: data,
        isCreate: false,
      };
    },
  },
  computed: {
    ...mapGetters("portfolio", ["portfolioAll"]),
    ...mapGetters("contacts", ["getParsedContactData"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions"]),
    ...mapGetters("role", ["checkRole"]),
    checkBulkActions() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item.toLowerCase() == "BULK CONTACT OPERATIONS".toLowerCase()) {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    checkEditContact() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item.toLowerCase() == "EDIT CONTACT".toLowerCase()) {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    tableColumns() {
      const self = this;
      let retval = [];
      let handleMenu = function (_cell, a, b) {
        _cell.getElement().addEventListener("click", () => {
          const ctxMenuData = [
            {
              title: "Delete",
              handler: () => {
                let data = _cell.getData();
                self.deleteItem = data;
                self.confirmMdlShow = true;
              },
            },
          ];
          if (self.checkEditContact) {
            ctxMenuData.push({
              title: "Edit",
              handler: () => {
                {
                  let data = _cell.getData();
                  self.handleEditContact(data);
                }
              },
            });
          }
          self.$root.$emit("contextmenu", { event, ctxMenuData });
        });

        return `
        <i class="fas fa-ellipsis-v" style="color:#0000004D;"></i>
        `;
      };
      retval = [
        {
          formatter: "rowSelection",
          titleFormatter: "rowSelection",
          align: "left",
          width: "20",
          headerSort: false,
          cellClick: function (e, cell) {
            cell.getRow().toggleSelect();
          },
        },
        {
          title: "Name",
          field: "name",
          sorter: "string",
          download: true,
        },
        {
          title: "Co-invested Company",
          field: "investedCompaniesLogoHtml",
          sorter: "string",
          formatter: "html",
          tooltip: false,
          download: true,
        },
        {
          title: "Founder of",
          field: "foundedCompaniesLogoHtml",
          sorter: "string",
          formatter: "html",
          tooltip: false,
          download: true,
        },
        {
          title: "Email",
          field: "email",
          sorter: "string",
          download: true,
        },
        {
          title: "Phone",
          field: "phone_number",
          sorter: "string",
          download: true,
        },
        {
          // minWidth: "40",
          width: "20",
          resizable: false,
          headerSort: false,
          responsive: 0,
          download: false,
          formatter: handleMenu,
        },
      ];
      if (self.checkRole == "Guest") {
        retval.pop();
      }
      return retval;
    },
  },
  watch: {
    getParsedContactData: _.debounce(function (newVal) {
      this.tableData = JSON.parse(JSON.stringify(newVal));
    }),
    searchQuery: _.debounce(function (newVal) {
      const self = this;
      if (!self.isFilterApplied || self.searchQuery.length == 0) {
        this.tabulator.clearFilter(true);
      }
      let appliedFilters = self.customFilterArray;
      self.searchFilter = [
        { field: "name", type: "like", value: self.searchQuery },
        {
          field: "investedCompaniesName",
          type: "like",
          value: self.searchQuery,
        },
        {
          field: "foundedCompaniesName",
          type: "like",
          value: self.searchQuery,
        },
        { field: "email", type: "like", value: self.searchQuery },
        { field: "phone_number", type: "like", value: self.searchQuery },
      ];
      if (appliedFilters.length == 0) {
        self.tabulator.setFilter([self.searchFilter]);
      } else {
        if (self.searchQuery && self.searchQuery.length > 0) {
          let tabulatorFilter = self.isFilterApplied
            ? [[self.searchFilter], [appliedFilters]]
            : [self.searchFilter];
          self.tabulator.setFilter(tabulatorFilter);
        } else {
          if (self.isFilterApplied) {
            self.tabulator.setFilter([appliedFilters]);
          }
        }
      }
    }, 300),
  },
  mounted() {
    let self = this;
    window.moment = moment;
    self.tabulator = new Tabulator(self.$refs.table, {
      layout: "fitColumns",
      index: "master_pid",
      tooltips: true,
      data: self.getParsedContactData,
      columns: self.tableColumns,
      tooltips: true,
      pagination: "local",
      paginationSize: 20,
      paginationSizeSelector: true,
      placeholder: "No records to view",
      rowSelectionChanged: function (data, rows) {
        if (self.tabulator && self.tabulator.getFilters().length) {
          if (data.length) {
            let checkboxData = JSON.parse(JSON.stringify(data));
            let filteredContacts = JSON.parse(
              JSON.stringify(self.tabulator.getData(true))
            );
            let arr = [];
            filteredContacts.map((item) => {
              let index = checkboxData.findIndex((items) => {
                if (item.master_pid == items.master_pid) {
                  return items;
                }
              });
              if (index >= 0) {
                arr.push(item);
              }
            });

            self.selectedContacts = arr;
          } else self.selectedContacts = data;
        } else {
          self.selectedContacts = data;
        }
      },
      dataFiltered: function (filters, rows) {
        //filters - array of filters currently applied
        //rows - array of row components that pass the filters
        if (self.tabulator && self.tabulator.getFilters().length > 0) {
          let filteredArray = [];
          filteredArray = self.tabulator.getData(true);
          if (filteredArray.length != rows.length) {
            filteredArray = rows.map((item) => {
              if (item && item._row && item._row.data) {
                return item._row.data;
              }
            });
          }
          if (self.selectedContacts && self.selectedContacts.length > 0) {
            let selectedContacts = JSON.parse(
              JSON.stringify(self.selectedContacts)
            );
            let arr = [];
            filteredArray.map((item) => {
              let index = selectedContacts.findIndex((items) => {
                if (item.master_pid == items.master_pid) {
                  return items;
                }
              });
              if (index >= 0) {
                arr.push(item);
              }
            });
            self.selectedContacts = arr;
          }
        } else {
          if (self.tabulator) {
            let totalData = self.tabulator.getData();
            self.selectedContacts =
              self.selectedContacts && self.selectedContacts.length > 0
                ? totalData
                : [];
          }
        }
      },
    });
  },
};
</script>
<style>
.filterBtn {
  border: 0px;
  border-radius: 8px;
  height: 40px !important;
  margin-top: auto;
  margin-bottom: auto;
}
.filterBtn:hover {
  background: #ebe9fb !important;
}

.filterDiv {
  z-index: 2;
  position: absolute;
  width: 341px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 8px #00000029;
  border-radius: 4px;
  transition: all 0.2s ease;
}
.filterForm {
  padding: 30px;
  border-bottom: 1px solid #00000029;
}
.checkFieldCls {
  color: #00000098;
  font-size: 13px;
  text-transform: capitalize;
}

.optionCompanyImage {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 5px;
}
.option__title {
  margin-top: auto;
  margin-bottom: auto;
}

.filterFormBtns {
  justify-content: space-between;
  padding: 5px;
}
</style>